import { FontSizes, FontWeights, Icon, ILabelStyles, Label, Stack } from "@fluentui/react";
import React from "react";

interface ISuccessErrorMessageProps {
    isSuccess?: boolean;
    isError?: boolean;
    successMessage?: string;
    errorMessage?: string;
    errorList?: string[];
}

export const SuccessErrorMessage = (props: ISuccessErrorMessageProps) => {
  const { isSuccess, isError, successMessage, errorMessage, errorList} = props
  
  return (
    <>
      {isSuccess && (
        <Stack style={successStyle} horizontal verticalAlign="center" horizontalAlign="start">
          <Icon iconName="CheckMark" styles={{ root: { color: "#107c10", padding: 0, margin: 0, paddingRight: 15, fontSize: 18, fontWeight: "bold" } }} />
          <Label styles={successLabel}>
            {successMessage}
          </Label>
        </Stack>
      )}
      {isError && (
        <div style={errorStyle} >
          <Stack horizontal verticalAlign="center" horizontalAlign="start">
            <Label styles={errorLabel}>
              {errorMessage}
            </Label>
          </Stack>
          <ul>{errorList?.filter(Boolean).map((item, index) => (<li key={index}><span style={{ color: "#a80000" }}>{item}</span></li>))}</ul>
        </div>
      )}
    </>
  );
};

const responseStyle: React.CSSProperties = {
  padding: 15,
}

const errorStyle: React.CSSProperties = {
  ...responseStyle,
  backgroundColor: "#fde7e9",
}

const errorLabel: ILabelStyles = {
  root: {
      fontSize: FontSizes.size16,
      fontWeight: FontWeights.semibold,
      margin: 0,
      padding: 0,
      color: "#a80000",
      textAlign: 'center'
  }
}

const successStyle: React.CSSProperties = {
  ...responseStyle,
  backgroundColor: "#dff6dd",
}

const successLabel: ILabelStyles = {
  root: {
      fontSize: FontSizes.size14,
      fontWeight: FontWeights.regular,
      margin: 0,
      padding: 0,
      color: "#107c10",
  }
}
